import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import renderToggleButtonField from '../../../form/ToggleButton';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Query, Mutation } from 'react-apollo';
import { loadFrameworks, loadEnabledFrameworks, loadSummary } from '../../../../redux/actions/complianceActions';
import { signout } from '../../../../redux/actions/userActions';
import frameworkMapping from '../../../../utils/frameworkMapping';
import { GetSummary, EnableFramework, DisableFramework } from '../../../../queries/frameworks'

class ComplianceToggleForm extends PureComponent {

    state = {
        controls: [],
        reload: false
    }

    signoutUser () {
        this.props.signout();
        this.props.history.push('/');
    }

    render () {
        return (
            <div style={{ paddingTop: '75px' }}>

                <h3 className='compliance-toggle-title'>Available Frameworks</h3>
                <hr />
                <Query
                    query={GetSummary()}
                    fetchPolicy={'network-only'}
                    skip={!this.state.reload}
                    onError={(e) => {

                        if (e.networkError) {
                            if (e.networkError['statusCode'] === 401) {
                                this.signoutUser()
                            }
                        } else {
                            console.log(e.message)
                            this.signoutUser()
                        }
                    }}
                    onCompleted={(data) => {
                        if (data) {

                            this.props.loadSummary(data.summary);
                            this.props.loadEnabledFrameworks(
                                data.summary.frameworkSummary.filter(f =>
                                    f.active === true).map(f =>
                                        frameworkMapping[f.frameworkID]).sort((a, b) =>
                                            a.frameworkID - b.frameworkID))
                            this.props.loadFrameworks(
                                data.summary.frameworkSummary.map(f => {
                                    return {
                                        ...frameworkMapping[f.frameworkID],
                                        enabled: f.active
                                    }
                                }).sort((a, b) => a.frameworkID - b.frameworkID))
                        }
                    }}>
                    {({ loading, error, data }) => {
                        if (loading) return null;
                        if (error) { console.log(`ERROR > ${error.message}`); return null }
                        return null
                    }}
                </Query>
                <Mutation
                    mutation={EnableFramework}
                    refetchQueries={[{
                        query: GetSummary(),
                    }]}>
                    {(enableFramework, { setEnabledData }) => (
                        <Mutation mutation={DisableFramework}
                            refetchQueries={[{
                                query: GetSummary(),
                            }]}>
                            {(disableFramework, { disableEnableData }) => (
                                <div style={{ margin: '0 70px 0 70px' }}>
                                    {
                                        this.props.frameworks.map(framework => {
                                            return (framework.id ?
                                                <Field
                                                    className='compliance-label'
                                                    key={framework.id}
                                                    _key={framework.id}
                                                    name={framework.name}
                                                    label={framework.manageFrameworksName}
                                                    toggle={framework.name}
                                                    defaultChecked={framework.enabled}
                                                    saveChange={(id, enabled) => {
                                                        if (enabled) {
                                                            enableFramework({ variables: { frameworkID: id } })
                                                        } else {
                                                            disableFramework({ variables: { frameworkID: id } })
                                                        }
                                                        this.setState({ reload: true })
                                                    }}
                                                    component={renderToggleButtonField} /> : null
                                            )
                                        })
                                    }
                                </div>
                            )}
                        </Mutation>
                    )}
                </Mutation>
                <hr />
                {/* <div className='avail-frameworks'>
                    <div className='left-button'>
                        <Button onClick={this.toggle}>Suggest a framework</Button>
                    </div>
                    <div className='right-button'>
                        <Button 
                        className='btn btn-primary feedback' 
                        color='#56BFF8' 
                        onClick={this.toggle}>Send Feedback</Button>
                    </div>
                </div> */}
            </div>
        )

    }

}

function mapStateToProps (state) {
    return {
        frameworks: state.controlsData.frameworks,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        summary: state.controlsData.summary,
    }
}

export default connect(mapStateToProps, {
    loadFrameworks,
    loadEnabledFrameworks,
    signout,
    loadSummary
})(withRouter(reduxForm({
    form: 'compliance_toggle_form', // a unique identifier for this form
})(ComplianceToggleForm)))



// WEBPACK FOOTER //
// ./src/components/dashboards/posture-dash/components/ComplianceToggleForm.js